import { Model, fields } from '@gasman/smush';

/* FIXME: editor state needs to be dependent on the engine (min/max pattern number, per-channel patterns...) */
class PatternEditorState extends Model([
    new fields.IntegerField('octave', {
        label: 'Octave',
        min: 1,
        max: 8,
        default: 4,
    }),
    new fields.IntegerField('sampleNumber', {
        label: 'Sample',
        min: 0,
        max: 15,
        default: 0,
    }),
    new fields.IntegerField('patternNumber', {
        label: 'Pattern',
        min: 1,
        max: 31,
        default: 1,
    }),
    new fields.BooleanField('isFollowingPlayback', { default: false }),
]) {}

export { PatternEditorState };
